import './opportunitiesFilter.scss'
import {EntitiesSortingOrder, OpportunityFilterUi} from "../../model/OpportunityFilterUi";
import {IComponentController, IComponentOptions} from "angular";
import {ALL_CALCULATORS} from "../../../calculations/model/Calculator";
import {UserService} from "../../../users_service/service/user.service";
import {ToastNotificationServiceName, UserServiceName} from "../../../utils/names/serviceNames";
import {UserView} from "../../../users/model/UserFilter";
import {UserDto} from "../../../users/model/User";
import {ToastNotificationService} from "../../../utils/ToastNotificationService";


export class OpportunitiesFilter implements IComponentController {

    static instance: IComponentOptions = {
        controller: [UserServiceName, ToastNotificationServiceName, OpportunitiesFilter],
        template: require('./opportunitiesFilter.html'),
        bindings: {
            onFilterValueChange: '<',
            successToggle: '<',
            calculationType: '<',
            filter: '<'
        }
    };

    private onFilterValueChange: (filterVal: OpportunityFilterUi) => void;
    private showOnlySuccess: boolean = false;
    private filter: OpportunityFilterUi;
    private now: Date;
    private inculudeCalculationType: boolean;
    private successToggle: boolean;
    private calculationType: boolean;

    constructor(private userService: UserService,
                private toastNotificationService: ToastNotificationService) {
        this.now = new Date(Date.now());
    }

    $onInit = () => {
        this.successToggle = this.successToggle != null;
        this.inculudeCalculationType = this.calculationType || false;
        this.filter = this.filter || {
            isSuccess: (this.successToggle) ? undefined : true,
            startDate: undefined,
            endDate: new Date(Date.now()),
            customerName: undefined,
            calculatorNames: ALL_CALCULATORS,
            employees: [],
            sortingOrder: EntitiesSortingOrder.NEW_FIRST,
            branchNames: [],
            brandName: [],
            importTypes: []
        };
        this.showOnlySuccess = this.filter.isSuccess != undefined;
        this.submitFilterValueChanges(this.filter);
    };

    toggleOnlySuccess = () => {
        if (this.showOnlySuccess) {
            this.filter.isSuccess = true;
        } else {
            this.filter.isSuccess = undefined;
        }
    };

    fetchEmployees = (query: string): angular.IPromise<UserDto[]> => {
        return this.userService.queryEmployee({
            branchesIds: this.filter.branchNames,
            showDeleted: false,
            showDisabled: true,
            userIds: [],
            query: query,
            view: UserView.AUTOCOMPLETE
        }).then((resp) => {
            if (resp.status == 200) {
                return resp.data;
            } else {
                this.toastNotificationService.generateErrorMessage('Failed to fetch users')
            }
        })
    };

    onEmployeeFilterValueChange = (employeeIds: number[]) => {
        this.filter.employees = employeeIds;
        if (employeeIds && employeeIds.length) {
            this.submitFilterValueChanges(this.filter);
        }
    };

    submitFilterValueChanges = (filterValue: OpportunityFilterUi): void => {
        this.onFilterValueChange(filterValue);
    };

    checkForSubmit = ($event) => {
        if ($event.which === 13) {
            this.submitFilterValueChanges(this.filter);
        }
    };

}